"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var typedi_1 = require("typedi");
var vue_1 = tslib_1.__importDefault(require("vue"));
var vue_class_component_1 = require("vue-class-component");
var utils_1 = require("./utils");
function Inject(typeOrName) {
    return function (target, propertyName, index) {
        if (target instanceof vue_1.default) {
            // Use special injection method
            var identifier_1;
            if (typeof typeOrName === 'string') {
                identifier_1 = typeOrName;
            }
            else if (typeOrName instanceof typedi_1.Token) {
                identifier_1 = typeOrName;
            }
            else {
                identifier_1 = Reflect.getMetadata('design:type', target, propertyName);
            }
            var value_1 = function () { return typedi_1.Container.get(identifier_1); };
            var decorator = vue_class_component_1.createDecorator(function (options) {
                utils_1.setInjection(options, propertyName, value_1);
            });
            decorator(target, propertyName, index);
        }
        else {
            // Use typedi inject
            var decorator = typedi_1.Inject(typeOrName);
            decorator(target, propertyName, index);
        }
    };
}
exports.Inject = Inject;
function Injectable() {
    return function (target) {
        var handlers = typedi_1.Container.handlers.filter(function (handler) { return handler.object.constructor === target; });
        var type = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var instance = new (target.bind.apply(target, [void 0].concat(args)))();
            handlers.forEach(function (handler) {
                if (handler.propertyName) {
                    instance[handler.propertyName] = handler.value(typedi_1.Container.of(undefined));
                }
            });
            return instance;
        };
        type.prototype = target.prototype;
        return type;
    };
}
exports.Injectable = Injectable;
//# sourceMappingURL=decorators.js.map